import React, { useCallback, useState } from "react";
import { Form } from "@unform/web";

import {
    MainButton,
    Modal,
    Pagination,
    LocalLoading,
    InputMask,
} from "../../../global";

import { useLoading } from "../../../../shared/hooks/useLoading";

import { IProperty } from "../../../../shared/interfaces/IProperties";
import { formatFilter } from "../../../../shared/utils/fields.utils";
import { GaTable } from "../component/table";
import { GuiaAmarelaApiService } from "../../../../shared/services/api/guia-amarela-api.service";

const LIMIT = 20;

export const GaForm: React.FC = () => {
    const { setLoading } = useLoading();
    const [localLoading, setLocalLoading] = useState<boolean>(false);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [properties, setProperties] = useState<Partial<IProperty>[]>([]);
    const [filters, setFilters] = useState<Record<string, string>>();
    const [propertiesAmount, setPropertiesAmount] = useState<number>(0);

    const toggleModalState = useCallback(() => {
        setShowModal(!showModal);
    }, [showModal]);

    const fechProperties = useCallback(
        async (page: number, form: Record<string, string> | undefined) => {
            const where = form ? formatFilter(form) : undefined;

            const query = `offset=${
                (page - 1) * LIMIT
            }&limit=${LIMIT}&where=${JSON.stringify(
                where
            )}&orderBy=ASC:inscricaoimobiliaria`;

            const propertiesResponse =
                await GuiaAmarelaApiService.listProperties(query, ["geom"]);

            setPropertiesAmount(propertiesResponse.paginate.total);

            setProperties(propertiesResponse.data || []);
        },
        []
    );

    const handleQueryPaginate = async (page: number) => {
        try {
            setLocalLoading(true);
            await fechProperties(page, filters);
        } finally {
            setLocalLoading(false);
        }
    };

    const handleSubmit = useCallback(
        async (form: Record<string, string>) => {
            setLoading(true);
            try {
                setFilters(form);
                await fechProperties(1, form);

                toggleModalState();
            } finally {
                setLoading(false);
            }
        },
        [setLoading, fechProperties, toggleModalState]
    );

    return (
        <>
            <Modal
                show={showModal}
                handleCloseModal={toggleModalState}
                size="xl"
                title="PROPRIEDADES"
            >
                <div className="h-96">
                    {localLoading ? (
                        <LocalLoading />
                    ) : (
                        <GaTable
                            properties={properties}
                            doAfterActionsClick={toggleModalState}
                        />
                    )}
                </div>

                <Pagination
                    totalOfPages={Math.ceil(propertiesAmount / LIMIT)}
                    doAfterClick={handleQueryPaginate}
                    totalOfItems={propertiesAmount}
                    maxItemsToDisplay={LIMIT}
                />
            </Modal>
            <div className="mt-4 container mx-auto text-center">
                <div className="flex justify-center">
                    <div className="w-full max-w-lg">
                        <h1 className="text-4xl font-light text-black mt-4">
                            Guia Amarela
                        </h1>
                        <p className="text-lg text-black mt-2">
                            Inscrição Imobiliária
                        </p>
                        <Form onSubmit={handleSubmit}>
                            <InputMask
                                name="inscricaoimobiliaria"
                                placeholder="00.00.00.000.0000"
                                mask="99.99.99.999.9999"
                                className="w-full p-4 border-2 border-gray-300 rounded-lg text-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                            <div className="w-full flex justify-center mt-4">
                                <div className="w-2/4 h-10">
                                    <MainButton type="submit">
                                        CONSULTAR
                                    </MainButton>
                                </div>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </>
    );
};
